module.exports = __webpack_public_path__ + "img/背景.dac3c61e.jpg";